import { z } from 'zod';
import { baseTaskSchema } from '../schema.base.js';
import { inTableCheckboxInput } from './input.checkbox.js';
import { inTableFractionInput } from './input.fraction.js';
import { inTableImageInput } from './input.image.js';
import { inTableReadonlyInput } from './input.readonly.js';
import { inTableTextInput } from './input.text.js';

const writeAnswersInTableTaskSchema = baseTaskSchema.extend({
  taskType: z.literal("WriteAnswers"),
  answerType: z.literal("InTable"),
  answerGroups: z.record(z.string(), z.array(z.string())).default({}),
  table: z.object({
    headers: z.array(z.object({
      text: z.string().optional().default(""),
      style: z.object({
        align: z.enum(["Left", "Center", "Right"]).default("Center")
      }).default({
        align: "Center"
      })
    })),
    cells: z.array(z.array(z.union([inTableCheckboxInput.schema, inTableImageInput.schema, inTableReadonlyInput.schema, inTableTextInput.schema, inTableFractionInput.schema])))
  })
}).transform(({
  answerGroups,
  table,
  ...rest
}) => ({
  ...rest,
  tableColumnHeadings: table.headers,
  content: table.cells.flatMap((row, rowIndex) => row.map((input, inputIndex) => {
    switch (input.type) {
      case "Checkbox":
        return inTableCheckboxInput.postprocessSchemaInput(input, {
          taskId: rest.id,
          index: inputIndex,
          rowIndex: rowIndex
        });
      case "Fraction":
        return inTableFractionInput.postprocessSchemaInput(input, {
          taskId: rest.id,
          index: inputIndex,
          rowIndex: rowIndex
        });
      case "Image":
        return inTableImageInput.postprocessSchemaInput(input, {
          taskId: rest.id,
          index: inputIndex,
          rowIndex: rowIndex
        });
      case "ReadOnly":
        return inTableReadonlyInput.postprocessSchemaInput(input, {
          taskId: rest.id,
          index: inputIndex,
          rowIndex: rowIndex
        });
      case "Writeable":
        return inTableTextInput.postprocessSchemaInput(input, {
          answerGroups,
          taskId: rest.id,
          index: inputIndex,
          rowIndex: rowIndex
        });
    }
  }))
}));

export { writeAnswersInTableTaskSchema };
//# sourceMappingURL=_schema.js.map
